var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboard-table-list-section"},[_c('Table',{attrs:{"columns":_vm.tblColumns,"data":_vm.leaderboardData,"width":"auto","size":"small","loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }